import React from 'react';

interface ActionBarProps {
  /** Shown when true; animates in from below. */
  visible: boolean;
  /** Left side: status text, e.g. "3 fält ändrade". */
  status?: React.ReactNode;
  /** Right side: the buttons. */
  children: React.ReactNode;
  className?: string;
}

/**
 * Sticky commit bar for desktop forms. It appears only when there is
 * something to commit, so an untouched workspace shows no Spara at all and
 * a dirty one cannot hide it below the fold. Sits inside the content column,
 * never over the sidebar.
 */
export function ActionBar({ visible, status, children, className = '' }: ActionBarProps) {
  if (!visible) return null;
  return (
    <div
      role="region"
      aria-label="Osparade ändringar"
      className={`sticky bottom-4 z-30 mt-6 animate-slide-up ${className}`}
    >
      <div className="flex items-center justify-between gap-4 rounded-ios-card border border-[var(--border-default)] bg-[var(--bg-surface)] px-4 py-3 shadow-ios-elevated">
        <div className="text-sm text-[var(--text-secondary)]">{status}</div>
        <div className="flex items-center gap-2">{children}</div>
      </div>
    </div>
  );
}

export default ActionBar;
